import React, { Component } from "react";
import { Modal, Row, Col, Form, Input, DatePicker, Button } from "antd";
import PageLayout from "../../ui/PageLayout";
import http from "../../../axios/http";
import server from "../../../axios/server";
import messager from "../../ui/messager";
const FormItem = Form.Item;

class AddMemberParkInfoForm extends Component {
  constructor(props) {	// eslint-disable-line 
    super(props);
  }
  state = {
    loadData: "",
    queryData: {
      pageNumber: 1,
      pageSize: 10,
      memberCode: "",
      keyword: "",
    },
    memberName: "",
  };
  columns = [
    {
      title: "车架号",
      dataIndex: "vin",
      width: "20%",
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "20%",
    },
    {
      title: "选择",
      dataIndex: "id",
      render: (text, record, index) => {
        if (!record.inPark) {
          return (
            <div>
              <Button onClick={this.selectVehicle.bind(this, record)}>
                选择
              </Button>
            </div>
          );
        } else {
          return <div>已在库</div>;
        }
      },
    },
  ];
  keywordSearch = (val) => {
    let queryData = this.state.queryData;
    queryData.keyword = val;
    this.state.loadData(queryData);
  };
  selectVehicle = (info, e) => {
    this.setState({ vehicleId: info.id, plateNo: info.plateNo, vin: info.vin });
  };

  onDateChange = (item, val) => {
    console.log(val);
    var state = this.state;
    state.inTime = val;
    this.setState(state);
  };

  save = () => {
    const { memberCode, zone, form } = this.props;
    const { vehicleId, inTime } = this.state;
    if (!vehicleId) {
      messager.alert("请先选择入场车辆");
      return;
    }
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      values["vehicleId"] = vehicleId;
      values["memberCode"] = memberCode;
      values["zone"] = zone;
      values["inTime"] = inTime;
      console.log(values);
      http.post({
        url: "/barrier/vehicleParkInfo/addParkInfo",
        data: values,
        success: (res) => {
          http.post({
            url:
              server.mallServerUrl + "/externalApi/barrier/updateParkInfoCache",
            data: { id: res.parkId },
            success: (res2) => {
              console.log("mallapi停车缓存刷新成功");
            },
          });
          messager.notify("保存成功");
          this.props.onCancel();
        },
      });
    });
  };

  componentWillReceiveProps(nextProp) {
    console.log(nextProp);
    var lastVisible = this.props.visible;
    var { visible, memberCode, zone } = nextProp;
    if (visible && !lastVisible) {
      let queryData = this.state.queryData;
      queryData.memberCode = memberCode;
      queryData.zone = zone;
      queryData.keyword = "";
      queryData.pageNumber = 1;
      queryData.pageSize = 10;
      this.setState({
        queryData,
        vehicleId: "",
        plateNo: "",
        vin: "",
        inTime: "",
      });
      if (this.state.loadData) this.state.loadData(queryData);
    }
  }

  render() {
    const { visible, onCancel, memberName } =
      this.props;
    return (
      <Modal
        visible={visible}
        width={1000}
        height={800}
        title={`新增[${memberName}]停车数据`}
        okText="新增"
        cancelText="取消"
        maskClosable={false}
        onCancel={onCancel}
        onOk={this.save}
      >
        {this.modalCotent()}
      </Modal>
    );
  }
  resetVehicle() {
    this.setState({ vehicleId: null, plateNo: "", vin: "" });
  }
  modalCotent() {
    const { form, memberCode, memberName } =
      this.props;
    const { getFieldDecorator } = form;
    const { vehicleId } = this.state;
    if (!vehicleId) {
      return (
        <div style={{ width: "100%", height: "500px" }}>
          <PageLayout
            condition={
              <Row>
                <Col span={6}>
                  <Input.Search
                    key={this.state.queryData.keyword}
                    defaultValue={this.state.queryData.keyword}
                    placeholder="关键字"
                    onSearch={this.keywordSearch}
                    enterButton
                  />
                </Col>
              </Row>
            }
            rowKey="id"
            url="/barrier/vehicleParkInfo/queryMemberNotInParkVehicle"
            columns={this.columns}
            initParams={{ memberCode, pageNumber: 1, pageSize: 10 }}
            loadData={(func) => {
              console.log("detial props", this.props);
              this.setState({
                queryData: { memberCode, pageNumber: 1, pageSize: 10 },
                memberName,
              });
              setTimeout(() => {
                this.setState({
                  loadData: func,
                });
              }, 1000);
            }}
          />
        </div>
      );
    } else {
      return (
        <Form
          layout="vertical"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 15 }}
        >
          <FormItem label="车牌号：">
            {this.state.plateNo}
            <Button onClick={this.resetVehicle.bind(this)}>选择其他</Button>
          </FormItem>
          <FormItem label="车架号：">{this.state.vin}</FormItem>
          <FormItem label="入场时间：">
            {getFieldDecorator("inTime", {
              rules: [{ required: true, message: "请输入入场时间" }],
            })(
              <DatePicker
                showTime
                format="YYYY-MM-DD HH:mm"
                key={this.state.inTime}
                onChange={this.onDateChange}
              />
            )}
          </FormItem>
        </Form>
      );
    }
  }
}

const AddMemberParkInfo = Form.create()(AddMemberParkInfoForm);

export default AddMemberParkInfo;
